module.exports = __webpack_public_path__ + "img/suyatsu_modal2.bb543d45.png";